import { getPiercingAppointmentIds } from '../helpers';

export const config = {
  excludedPaths: [
    '/piercing-type',
    '/welding-type',
  ],
  appointmentsIds: getPiercingAppointmentIds(), // appointment id's
};
